<template>
    <div>
        <div class="ibox-content" data-cy="client-data-form-box">
            <div class="row ">
                <div class="col-10">
                    <h4 class="m-b">{{ boxTitle }}<button v-if="addNipEuVisible" type="button" class="btn btn-primary btn-sm ml-2" @click="checkAndUpdateSecondaryNumber()">Dodaj NIP UE</button></h4>
                </div>
                <div
                    class="col-2 text-right"
                    v-if="
                        deleteButton &&
                            !disabled &&
                            mode != 'application-settings'
                    "
                >
                    <i
                        class="fa fa-trash tooltip-more"
                        title=""
                        :data-original-title="__('delete')"
                        @click="deleteForm"
                    ></i>
                </div>
            </div>

            <div
                class="form-group row m-b-sm"
                v-if="copyClientDataButton && mode != 'application-settings'"
            >
                <div class="col-12">
                    <label
                        ><input
                            type="checkbox"
                            :disabled="!isEnabledCopyButton"
                            @click="copyClientData"
                            @input="updateForm"
                            :checked="isCopyClientData"
                            name="copyClientData"
                            data-cy="client-data-form-copy-client-data"
                            :value="true"
                        />
                        {{ __("copy_client_data") }}</label
                    >
                </div>
            </div>
            <fieldset :disabled="disabled">
                <div class="form-group row m-b-sm">
                    <div
                        class="col-md-4"
                        :class="hasError('name') ? 'has-error' : ''"
                        data-cy="client-data-form-name-input-div"
                    >
                        <input-wrapper
                            :label="
                                __(
                                    'company_name_or_first_name_and_second_name'
                                ) + '*'
                            "
                            type="text"
                            classNames="form-control"
                            name="name[]"
                            data-cy="client-data-form-name-input"
                            v-model="formData.name"
                            @input="updateForm"
                            :errors="getErrors('name')"
                        />
                    </div>

                    <div
                        class="col-md-2"
                        :class="hasError('countrySelected') ? 'has-error' : ''"
                        data-cy="client-data-form-country-selected-div"
                    >
                        <label>{{ __("country") }}*</label>
                        <select-2
                            :options="countriesSelect2"
                            :settings="countriesSelect2Settings"
                            v-model="formData.countrySelected"
                            name="countrySelected[]"
                            data-cy="client-data-form-country-selected"
                            @change="countryChanged"
                            @input="updateForm"
                            :disabled="
                                disabled || mode == 'application-settings'
                            "
                        />
                        <span
                            class="help-block text-danger"
                            v-if="hasError('countrySelected')"
                            data-cy="client-data-form-country-selected-span"
                        >
                            {{ getError("countrySelected") }}
                        </span>
                    </div>

                    <div class="col-md-6">
                        <div class="row">
                            <div
                                class="col-md-4"
                                data-cy="client-data-form-idNumber-Type-one-selected-div"
                                :class="
                                    hasError('idNumberType') ? 'has-error' : ''
                                "
                            >
                                <label
                                    >{{
                                        __("identification_number_id")
                                    }}*</label
                                >
                                <select-2
                                    :options="filteredidNumbersSelect2"
                                    :settings="{ width: '100%' , templateResult: (option) => {
                                            return option.deleted_at === null ? option.text : null;
                                        },}"
                                    v-model="formData.idNumberType"
                                    name="idNumberType[]"
                                    data-cy="client-data-form-idNumber-Type-one-selected"
                                    :disabled="
                                        formData.countrySelected == null ||
                                            disabled ||
                                            mode == 'application-settings'
                                    "
                                    @change="idNumberChanged"
                                    @input="updateForm"
                                />
                                <span
                                    class="help-block text-danger"
                                    v-if="hasError('idNumberType')"
                                    data-cy="client-data-form-idNumber-Type-one-span"
                                >
                                    {{ getError("idNumberType") }}
                                </span>
                            </div>

                            <div class="col">
                                <div
                                    :class="
                                        hasError('idNumber') ? 'has-error' : ''
                                    "
                                    data-cy="client-data-form-idNumber-input-one-div"
                                >
                                    <input-wrapper
                                        :label="
                                            __('identification_number') + '*'
                                        "
                                        type="text"
                                        classNames="form-control"
                                        name="idNumber[]"
                                        data-cy="client-data-form-idNumber-input-one"
                                        v-model="formData.idNumber"
                                        @input="updateForm"
                                        :errors="getErrors('idNumber')"
                                        :readonly="!isSelectedIdNumber || (!!idVies && index == 0)"
                                        :disabled="
                                            mode == 'application-settings'
                                        "
                                    >
                                        <template
                                            v-slot:append
                                            v-if="
                                                isIdNumberNip &&
                                                    !disabled &&
                                                    mode !=
                                                        'application-settings'
                                                        && formData.departmentCountryChecked === false
                                            "
                                        >
                                            <button
                                                type="button"
                                                class="btn btn-primary"
                                                data-cy="client-data-form-idNumber-input-btn-one"
                                                v-tooltip="
                                                    __('get_data_from_gus')
                                                "
                                                @click="
                                                    getDataFromGUS('idNumber')
                                                "
                                            >
                                                <i class="fas fa-search"></i>
                                            </button>
                                        </template>
                                    </input-wrapper>
                                </div>
                            </div>

                            <div
                                class="col-md-auto text-center"
                                v-if="
                                    viesButton && mode != 'application-settings'
                                "
                            >
                                <label>VIES</label><br />
                                <input
                                    type="checkbox"
                                    style="margin-top:8px;"
                                    name="idNumberVies"
                                    data-cy="client-data-form-VIES-checkbox-one"
                                    v-model="idVies"
                                    @click="idViesClick"
                                    :disabled="isViesDisabled(0)"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="row m-b-sm">
                            <div
                                class="col-md-12 m-b-sm"
                                :class="hasError('address1') ? 'has-error' : ''"
                                data-cy="client-data-form-adress-input-one-div"
                            >
                                <input-wrapper
                                    :label="__('address') + '*'"
                                    type="text"
                                    classNames="form-control"
                                    name="address1[]"
                                    data-cy="client-data-form-adress-input-one"
                                    v-model="formData.address1"
                                    @input="updateForm"
                                    :errors="getErrors('address1')"
                                />
                            </div>
                            <div
                                class="col-md-12 m-b-sm"
                                :class="hasError('address2') ? 'has-error' : ''"
                                data-cy="client-data-form-adress-input-two-div"
                            >
                                <input-wrapper
                                    type="text"
                                    classNames="form-control"
                                    name="address2[]"
                                    data-cy="client-data-form-adress-input-two"
                                    v-model="formData.address2"
                                    @input="updateForm"
                                    :errors="getErrors('address2')"
                                />
                            </div>
                            <div
                                class="col-md-6 m-b-sm"
                                :class="hasError('zip') ? 'has-error' : ''"
                                data-cy="client-data-form-zip-input-div"
                            >
                                <input-wrapper
                                    :label="__('zip') + '*'"
                                    type="text"
                                    classNames="form-control"
                                    name="zip[]"
                                    data-cy="client-data-form-zip-input"
                                    v-model="formData.zip"
                                    @input="updateForm"
                                    :errors="getErrors('zip')"
                                />
                            </div>
                            <div
                                class="col-md-6 m-b-sm"
                                :class="hasError('city') ? 'has-error' : ''"
                                data-cy="client-data-form-city-input-div"
                            >
                                <input-wrapper
                                    :label="__('city') + '*'"
                                    type="text"
                                    classNames="form-control"
                                    name="city[]"
                                    data-cy="client-data-form-city-input"
                                    v-model="formData.city"
                                    @input="updateForm"
                                    :errors="getErrors('city')"
                                />
                            </div>
                            <div
                                class="col-md-6 text-right"
                                style="padding-top:20px;"
                            >
                                <label
                                    ><input
                                        type="checkbox"
                                        v-model="
                                            formData.departmentCountryChecked
                                        "
                                        :name="
                                            'departmentCountryChecked[' +
                                                index +
                                                ']'
                                        "
                                        data-cy="client-data-form-department-checkbox"
                                        :true-value="true"
                                        :false-value="false"
                                        @change="departmentCountryChange"
                                        @input="updateForm"
                                        :disabled="
                                            mode == 'application-settings'
                                        "
                                    />
                                    {{ __("client_department") }}</label
                                >
                            </div>
                            <div
                                class="col-md-6"
                                :class="
                                    hasError('departmentCountrySelected')
                                        ? 'has-error'
                                        : ''
                                "
                                data-cy="client-data-form-department-country-selected-div"
                            >
                                <label>{{ __("department_country") }}*</label>
                                <select-2
                                    :options="countriesSelect2"
                                    :settings="countriesSelect2Settings"
                                    v-model="formData.departmentCountrySelected"
                                    data-cy="client-data-form-department-country-selected"
                                    name="departmentCountrySelected[]"
                                    :readonly="
                                        !formData.departmentCountryChecked
                                    "
                                    :disabled="
                                        disabled ||
                                            mode == 'application-settings'
                                    "
                                    @change="departmentCountryChanged"
                                    @input="updateForm"
                                />
                                <span
                                    class="help-block text-danger"
                                    v-if="hasError('departmentCountrySelected')"
                                    data-cy="client-data-form-department-country-selected-span"
                                >
                                    {{ getError("departmentCountrySelected") }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row m-b-sm">
                            <div
                                class="col-md-4"
                                :class="
                                    hasError('idNumberSecondaryType')
                                        ? 'has-error'
                                        : ''
                                "
                                data-cy="client-data-form-idNumber-Type-two-selected-div"
                            >
                                <label
                                    >{{
                                        __(
                                            "secondary_id_number_id"
                                        )
                                    }}*</label
                                >
                                <select-2
                                    :options="filteredidNumbersSelect2"
                                    :settings="{ width: '100%' , templateResult: (option) => {
                                            return option.deleted_at === null ? option.text : null;
                                        },}"
                                    v-model="formData.idNumberSecondaryType"
                                    name="idNumberSecondaryType[]"
                                    data-cy="client-data-form-idNumber-Type-two-selected"
                                    :disabled="
                                        formData.countrySelected == null ||
                                            disabled ||
                                            mode == 'application-settings'
                                    "
                                    @change="idNumberSecondaryChanged"
                                    @input="updateForm"
                                />
                                <span
                                    class="help-block text-danger"
                                    v-if="hasError('idNumberSecondaryType')"
                                    data-cy="client-data-form-idNumber-Type-two-selected-span"
                                >
                                    {{ getError("idNumberSecondaryType") }}
                                </span>
                            </div>

                            <div
                                class="col"
                                :class="
                                    hasError('idNumberSecondary')
                                        ? 'has-error'
                                        : ''
                                "
                                data-cy="client-data-form-idNumber-input-two-div"
                            >
                                <input-wrapper
                                    :label="__('identification_number') + '*'"
                                    type="text"
                                    classNames="form-control"
                                    name="idNumberSecondary[]"
                                    data-cy="client-data-form-idNumber-input-two"
                                    v-model="formData.idNumberSecondary"
                                    @input="updateForm"
                                    :errors="getErrors('idNumberSecondary')"
                                    :readonly="!isSelectedIdNumberSecondary || (!!idSecondaryVies && index == 0)"
                                    :disabled="mode == 'application-settings'"
                                >
                                    <template
                                        v-slot:append
                                        v-if="
                                            isSecondaryIdNumberNip &&
                                                !disabled &&
                                                mode != 'application-settings' && formData.departmentCountryChecked === false
                                        "
                                    >
                                        <button
                                            type="button"
                                            class="btn btn-primary "
                                            data-cy="client-data-form-idNumber-input-btn-two"
                                            v-tooltip="
                                                    __('get_data_from_gus')
                                                "
                                            @click="
                                                getDataFromGUS(
                                                    'idNumberSecondary'
                                                )
                                            "
                                        >
                                            <i class="fas fa-search"></i>
                                        </button>
                                    </template>
                                </input-wrapper>
                            </div>

                            <div
                                class="col-md-auto text-center"
                                v-if="
                                    viesButton && mode != 'application-settings'
                                "
                            >
                                <label>VIES</label><br />
                                <input
                                    type="checkbox"
                                    style="margin-top:8px;"
                                    name="idNumberSecondaryVies"
                                    data-cy="client-data-form-VIES-checkbox-two"
                                    v-model="idSecondaryVies"
                                    @click="idSecondaryViesClick"
                                    :disabled="isViesDisabled(1)"
                                />
                            </div>
                        </div>
                        <div
                            class="form-group"
                            v-if="mode != 'application-settings'"
                            data-cy="client-data-form-remerks-textarea-div"
                        >
                            <label>{{ __("remarks") }}</label>
                            <textarea
                                type="text"
                                class="form-control"
                                data-cy="client-data-form-remerks-textarea"
                                style="height:126px;"
                                v-model="formData.remarks"
                                name="remarks[]"
                                @input="updateForm"
                            ></textarea>
                        </div>
                        <div
                            class="form-group"
                            :class="hasError('city') ? 'has-error' : ''"
                            v-if="mode == 'application-settings' && shortName"
                            data-cy="client-data-form-shortname-input-div"
                        >
                            <input-wrapper
                                :label="__('own_name_in_the_application') + '*'"
                                type="text"
                                classNames="form-control"
                                name="short_name[]"
                                data-cy="client-data-form-shortname-input"
                                v-model="formData.short_name"
                                @input="updateForm"
                                :errors="getErrors('short_name')"
                            />
                        </div>
                        <div
                            class="form-group"
                            v-if="showLogo &&
                                ((mode == 'application-settings' &&
                                    isCopyClientData) ||
                                    (logo && formData.logo != undefined))
                            "
                        >
                            <label>{{ __("logo") }}</label>
                            <div
                                class="fileinput m-b-xs"
                                :class="
                                    formData.logo.path
                                        ? 'fileinput-exists'
                                        : 'fileinput-new'
                                "
                                data-provides="fileinput"
                            >
                                <span class="btn btn-primary btn-file"
                                    ><span class="fileinput-new">{{
                                        __("choose_file")
                                    }}</span>
                                    <span class="fileinput-exists">{{
                                        __("change")
                                    }}</span
                                    ><input type="file" :name="`logo[${index}]`"
                                /></span>

                                <span class="fileinput-filename m-l-sm">
                                    <span v-if="formData.logo.path">
                                        {{ formData.logo.name }}
                                        <input
                                            type="hidden"
                                            :name="`logo_exists[${index}]`"
                                        />
                                    </span>
                                </span>
                                <a
                                    href="#"
                                    class="close fileinput-exists"
                                    data-dismiss="fileinput"
                                    style="float: right"
                                    ><i class="fa fa-trash"></i
                                ></a>
                            </div>
                            <img
                                class="m-t m-b-sm img-fluid"
                                :src="formData.logo.path"
                            />
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import InputWrapper from "../../form/InputWrapper.vue";
import permissions from './../../../services/Permissions.js';

export default {
    components: {
        InputWrapper
    },
    data() {
        return {
            idVies: false,
            idSecondaryVies: false,
            isCopyClientData: false,
            formData: {
                name: "",
                id: "",
                update_number_in_instance_information_and_company:0,
                is_from_instance_information: 0,
                countrySelected: null,
                idNumberType: null,
                idNumber: "",
                idNumberSecondaryType: "",
                idNumberSecondary: "",
                address1: "",
                address2: "",
                zip: "",
                city: "",
                remarks: "",
                departmentCountryChecked: false,
                departmentCountrySelected: null,
                short_name: ""
            }
        };
    },
    props: {
        value: {
            type: Object,
            default: null
        },
        boxTitle: {
            type: String,
            default: ""
        },
        viesButton: {
            type: Boolean,
            default: false
        },
        deleteButton: {
            type: Boolean,
            default: false
        },
        copyClientDataButton: {
            type: Boolean,
            default: false
        },
        isEnabledCopyButton: {
            type: Boolean,
            default: false
        },
        id: {
            type: Number,
            default: -1
        },
        index: {
            type: Number,
            default: -1
        },
        countryProp: {
            default: null
        },
        idNumberTypeProp: {
            default: null
        },
        copyButtonChecked: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        logo: {
            type: Boolean,
            default: false
        },
        shortName: {
            type: Boolean,
            default: false
        },
        mode: {
            type: String
        },
        permission_access: {
            default: null
        },
    },
    computed: {
        addNipEuVisible(){
            return this.mode == 'application-settings' && this.formData.idNumberType == 5 && this.formData.idNumberSecondaryType == 18;
        },
        countriesSelect2Settings(){
            return {
                templateResult: (option) => {
                    return option.is_trashed === true ? null : option.text;
                },
                width: '100%',
            };
        },
        showLogo() {
            return permissions.getPermission(this.permission_access, 'perm_view_application.settings_crud_logo')
        },
        filteredidNumbersSelect2() {
            let filtered = this.idNumbersSelect2.filter(element => {
                let countryId = 0;
                if (this.formData.departmentCountryChecked) {
                    countryId = this.formData.departmentCountrySelected;
                } else {
                    countryId = this.formData.countrySelected;
                }
                return (
                    element.country_id == countryId ||
                    element.text == "other" ||
                    element.text == "none"
                );
            });

            let translated = [];
            filtered.forEach(element => {
                let tempElement = { ...element };
                tempElement.text = this.__(element.text);
                translated.push(tempElement);
            });

            return translated;
        },
        isSelectedIdNumber() {
            let inputName = this.idNumbersSelect2.find(
                element => element.id == this.formData.idNumberType
            );
            return (
                this.formData.idNumberType != null &&
                inputName != undefined &&
                inputName.text != "none"
            );
        },
        isSelectedIdNumberSecondary() {
            let inputName = this.idNumbersSelect2.find(
                element => element.id == this.formData.idNumberSecondaryType
            );
            return (
                this.formData.idNumberSecondaryType != null &&
                inputName != undefined &&
                inputName.text != "none"
            );
        },
        isIdNumberNip() {
            let number = this.filteredidNumbersSelect2.find(obj => {
                return obj.id == this.formData.idNumberType;
            });

            return number != undefined ? number.text == "NIP" : false;
        },
        isSecondaryIdNumberNip() {
            let number = this.filteredidNumbersSelect2.find(obj => {
                return obj.id == this.formData.idNumberSecondaryType;
            });

            return number != undefined ? number.text == "NIP" : false;
        },
        ...mapGetters({
            countriesSelect2: "getCountriesSelect2",
            idNumbersSelect2: "getIdNumbersTypes",
            selectedDepartment: "getSelectedSaDepartment",
            errors: "getErrors",
            old: "getOld",
            values: "getValues"
        })
    },
    methods: {
        async checkAndUpdateSecondaryNumber(){
            let response = await make_vies_simple_check_and_update_instance_information({
                'type': this.formData.idNumberType,
                'number': this.formData.idNumber,
                'update_number_in_instance_information_and_company': this.formData.update_number_in_instance_information_and_company,
                'is_from_instance_information' : this.formData.is_from_instance_information,
                'id': this.formData.id
            })
            if (response.valid) {
                handle_valid_response_vies_simple_check_and_update_information(response)
            } else {
                handle_invalid_response_vies_simple_check(response)
            }
        },
        isViesDisabled(index) {
            let countryId = -1;
            if (this.formData.departmentCountryChecked) {
                countryId = this.formData.departmentCountrySelected;
            } else {
                countryId = this.formData.countrySelected;
            }
            let country = this.countriesSelect2.find(
                element => element.id == countryId
            );
            let inputName = this.idNumbersSelect2.find(
                element => element.id == (index === 0 ? this.formData.idNumberType : this.formData.idNumberSecondaryType)
            )


            let result =  (inputName !== undefined && (inputName.text === "none" || inputName.can_be_vies == 0));
            if(result){
                this.resetViesCheckboxes(index);
            }
            return result;
        },
        resetViesCheckboxes(index) {
            if(index == 0){
                this.idVies = false;
            }
            else{
                this.idSecondaryVies = false;
            }
        },
        countryChanged() {
            if (this.formData.departmentCountryChecked == false) {
                this.$emit("changeCountry", this.formData.countrySelected);
                this.setDefaultIdNumbersSelects();
                this.$emit("chamgeIdType", this.formData.idNumberType);
            }
        },
        departmentCountryChanged() {
            if (
                this.formData.departmentCountryChecked == true ||
                this.formData.departmentCountryChecked == "on"
            ) {
                this.$emit(
                    "changeCountry",
                    this.formData.departmentCountrySelected
                );
                this.setDefaultIdNumbersSelects();
                this.$emit("chamgeIdType", this.formData.idNumberType);
            }
        },
        setDefaultIdNumbersSelects() {
            let isDefaultSelected = false;

            this.filteredidNumbersSelect2.forEach(element => {
                if (
                    element.related_type == "other_entities" &&
                    !isDefaultSelected
                ) {
                    this.formData.idNumberType = element.id;
                    isDefaultSelected = true;
                }
            });

            if (!isDefaultSelected) {
                if(this.filteredidNumbersSelect2[0].deleted_at == null){
                    this.formData.idNumberType = this.filteredidNumbersSelect2[0].id;
                }
                else{
                    this.filteredidNumbersSelect2.forEach(element => {
                        if (
                            element.text == "Inny"
                        ) {
                            this.formData.idNumberType = element.id;
                        }
                    });
                }
            }

            this.setSecondIdTypeNone();
        },
        departmentCountryChange() {
            this.$set(this.formData, "departmentCountrySelected", -1);
            this.setDefaultIdNumbersSelects();
            this.$emit("changeCountry", this.formData.countrySelected);
            this.$emit("chamgeIdType", this.formData.idNumberType);
        },
        idNumberSecondaryChanged() {
            let inputName = this.idNumbersSelect2.find(
                element => element.id == this.formData.idNumberSecondaryType
            );

            if (inputName != undefined && inputName.text == "none") {
                this.formData.idNumberSecondary = "";
            }
        },
        idNumberChanged() {
            let inputName = this.idNumbersSelect2.find(
                element => element.id == this.formData.idNumberType
            );

            this.$emit("chamgeIdType", this.formData.idNumberType);
            if (inputName != undefined && inputName.text == "none") {
                this.formData.idNumber = "";
            }
        },
        updateFormCountry() {
            this.formData.countrySelected =
                this.selectedDepartment.department_sa_detail.department_country_id != null
                    ? this.selectedDepartment.department_sa_detail.department_country_id
                    : this.selectedDepartment.department_sa_detail.country.id;

            if (this.formData.departmentCountryChecked == false) {
                this.setDefaultIdNumbersSelects();
                this.setSecondIdTypeNone();
            }
        },
        deleteForm() {
            $(function() {
                $(".tooltip").remove();
            });
            this.$emit("delete", this.id);
        },
        copyClientData() {
            this.$emit("copy");
        },
        updateForm() {
            this.$emit("input", this.formData);
        },
        async idViesClick() {
            if (this.idVies == false) {
                this.idSecondaryVies = false;
            }
            if (!this.idVies) {
                let response = await make_vies_simple_check({
                    'type': this.formData.idNumberType,
                    'number': this.formData.idNumber
                })
                if (response.valid) {
                    handle_valid_response_vies_simple_check(response)
                } else {
                    handle_invalid_response_vies_simple_check(response)
                    this.idVies = false;
                }
            }
        },
        async idSecondaryViesClick() {
            if (this.idSecondaryVies == false) {
                this.idVies = false;
            }
            if (!this.idSecondaryVies) {
                let response = await make_vies_simple_check({
                    'type': this.formData.idNumberSecondaryType,
                    'number': this.formData.idNumberSecondary
                })
                if (response.valid) {
                    handle_valid_response_vies_simple_check(response)
                } else {
                    handle_invalid_response_vies_simple_check(response)
                    this.idSecondaryVies = false;
                }
            }
        },
        hasError(inputName) {
            return this.errors[`${inputName}.${this.index}`] != undefined;
        },
        getErrors(inputName) {
            return this.errors[`${inputName}.${this.index}`] != undefined
                ? this.errors[`${inputName}.${this.index}`]
                : [];
        },
        getError(inputName) {
            return this.errors[`${inputName}.${this.index}`] != undefined
                ? this.errors[`${inputName}.${this.index}`][0]
                : [];
        },
        setData(data) {
            if (Object.keys(data).length != 0) {
                for (const [key, value] of Object.entries(data)) {
                    if (value != null && value[this.index] != undefined) {
                        this.$set(this.formData, key, value[this.index]);
                    }
                }

                if (data.idNumberVies) {
                    this.idVies = true;
                } else if (data.idNumberSecondaryVies) {
                    this.idSecondaryVies = true;
                }
            }
        },
        setSecondIdTypeNone() {
            let none = this.idNumbersSelect2.find(
                element => element.text == "none"
            );

            this.formData.idNumberSecondaryType = none.id;
            this.formData.idNumberSecondary = "";
        },
        getDataFromGUS(inputName) {
            let nip = this.formData[inputName];
            this.getGusInfo({ nip: nip }).then(response => {
                let data = response.data;

                if (data.success == true) {
                    this.updateClientFormFromGUS(data.data[0]);

                    toastr["info"](
                        this.__("clients_data_have_been_imported")
                    ).css("border", "0px");
                } else {
                    genericSwalGUSError();
                }
            });
        },
        updateClientFormFromGUS(data) {
            this.formData.name = data.name;
            let street = data.street.replace("ul. ", "");
            street = street.concat(" ", data.propertyNumber);

            if (data.apartmentNumber != "") {
                street = street.concat("/", data.apartmentNumber);
            }

            this.formData.address1 = street;
            this.formData.zip = data.zipCode;
            this.formData.city = data.postCity;
        },
        setFormData(){
            this.formData = this.value;
        },
        ...mapActions(["getGusInfo"])
    },

    mounted() {
        if (this.value != null) {
            this.formData = this.value;

            this.idVies = this.value.idVies
            this.idSecondaryVies = this.value.idSecondaryVies
        }
        if (this.formData.departmentCountrySelected == null) {
            this.formData.departmentCountrySelected = this.countriesSelect2[0].id;
        }
        if (this.countryProp != null) {
            this.formData.countrySelected = this.countryProp;
        } else if (this.formData.countrySelected == null) {
            this.formData.countrySelected = this.countriesSelect2[0].id;
        }
        if (this.idNumberTypeProp != null) {
            this.formData.idNumberType = this.idNumberTypeProp;
            let none = this.idNumbersSelect2.find(
                element => element.text == "none"
            );

            this.formData.idNumberSecondaryType = none.id;
        } else if (this.formData.idNumberType == null) {
            let isDefaultSelected = false;
            this.filteredidNumbersSelect2.forEach(element => {
                if (
                    element.related_type == "other_entities" &&
                    !isDefaultSelected
                ) {
                    this.formData.idNumberType = this.filteredidNumbersSelect2[0].id;
                    let none = this.idNumbersSelect2.find(
                        element => element.text == "none"
                    );

                    this.formData.idNumberSecondaryType = none.id;
                    this.formData.idNumberSecondary = "";
                }
            });
            if (!isDefaultSelected) {
                let none = this.idNumbersSelect2.find(
                    element => element.text == "none"
                );
                this.formData.idNumberType = this.filteredidNumbersSelect2[0].id;
                this.formData.idNumberSecondaryType = none.id;
            }
        }
        this.isCopyClientData = this.copyButtonChecked;
        if (!this.isCopyClientData ) {

            if (Object.keys(this.old).length != 0) {
                this.setData(this.old);
            }
         else if (Object.keys(this.values).length != 0 && (this.mode === 'edit' || this.mode === 'application-settings' || this.mode === 'edit-from-draft')) {
            this.setData(this.values);
        }
        }
    }
};
</script>

<style lang="scss" scoped>
.tooltip-more {
    &:hover {
        cursor: pointer;
    }
}
</style>
